<div class="app-habitation-v2 page">
  <div class="wrapper">
    <div class="hidden-mobile">
      <div class="habitation-nav">
        <app-breadcrumb></app-breadcrumb>
      </div>
    </div>
    <ng-content select="div.page-content"> </ng-content>
    <div class="clickToCall">
      <app-boite-aide></app-boite-aide>
    </div>
  </div>
</div>
